import React, { useEffect, useState } from 'react';
import {
    TableCell,
    TableRow,
    Button,
    Grid,
    ListItemText,
    Typography,
    Tooltip
} from '@material-ui/core';
import { MuiTable } from 'components';
import { index, pdf, shareByMail } from './api';
import CircularProgress from '@material-ui/core/CircularProgress';
import { toHumanReadableDateTime } from 'helpers/date';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import MailIcon from '@material-ui/icons/Mail';

const headers = [
    { id: 'aot.label', align: 'left', label: 'Libellé', sortable: true },
    {
        id: 'marche.libelleMarche',
        align: 'left',
        label: 'Marché',
        sortable: true,
        style: { width: '25%' }
    },
    { id: 'created_by.username', align: 'left', label: 'Créée par', sortable: true },
    { id: 'aot.sent_at', align: 'left', label: 'Envoyée le', sortable: false },
    { id: 'action', align: 'center', label: 'Actions', sortable: false, style: { width: '25%' } }
];

const Aot = ({ merchantId, hasEmail }) => {
    const [count, setCount] = useState(0);
    const [aots, setAots] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [mailSending, setMailSending] = useState(false);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState(headers[0].id);

    useEffect(() => {
        loading && getData();
    }, [loading]);

    useEffect(() => {
        setLoading(true);
    }, [order, orderBy, page]);

    const getData = () => {
        index(merchantId, { page, order, orderBy })
            .then(res => {
                setCount(res.count);
                setAots(res.data);
            })
            .catch(err => alert(err))
            .finally(() => setLoading(false));
    };

    const sendAot = aotMerchantId => {
        shareByMail(aotMerchantId)
            .then(() => alert('Aot envoyée avec succès'))
            .catch(err => alert(err))
            .finally(() => setMailSending(false) || setLoading(true));
    };

    return (
        <MuiTable
            refresh={() => setLoading(true)}
            loading={loading}
            headers={headers}
            page={{
                set: val => setPage(val),
                data: page,
                count: count
            }}
            order={{
                set: val => setOrder(val),
                data: order
            }}
            orderBy={{
                set: val => setOrderBy(val),
                data: orderBy
            }}>
            {aots.map((aot, index) => (
                <TableRow hover key={`${index}-${aot.id}`}>
                    <TableCell align="left" key={`ref-${index}-${aot.id}`}>
                        {aot.label}
                    </TableCell>
                    <TableCell align="left" key={`libelleMarche-${index}-${aot.id}`}>
                        <ListItemText
                            primary={aot.libelleMarche}
                            secondary={
                                <Typography variant="body2">
                                    Place {aot.sector ?? null}
                                    {aot.numeroPlace} {aot.holder ? ' - abonné' : null}
                                </Typography>
                            }
                        />
                    </TableCell>
                    <TableCell align="left" key={`created-${index}-${aot.id}`}>
                        <ListItemText
                            primary={aot.username}
                            secondary={
                                <Typography variant="body2">
                                    {toHumanReadableDateTime(aot.created_at.date)}
                                </Typography>
                            }
                        />
                    </TableCell>
                    <TableCell align="left" key={`sent-${index}-${aot.id}`}>
                        {aot.sent_at === null ? null : toHumanReadableDateTime(aot.sent_at.date)}
                    </TableCell>
                    <TableCell align="center" key={`action-${index}-${aot.id}`}>
                        <Grid container direction="row" spacing={1}>
                            <Grid item>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    endIcon={<PictureAsPdfIcon />}
                                    onClick={() => pdf(aot.id)}
                                    size="small">
                                    Afficher
                                </Button>
                            </Grid>
                            <Grid item>
                                {hasEmail ? (
                                    <Button
                                        onClick={() => setMailSending(true) || sendAot(aot.id)}
                                        size="small"
                                        color="secondary"
                                        variant="contained"
                                        endIcon={
                                            mailSending ? (
                                                <CircularProgress color="inherit" size={18} />
                                            ) : (
                                                <MailIcon />
                                            )
                                        }>
                                        {aot.sent_at === null ? 'Envoyer' : 'Renvoyer'}
                                    </Button>
                                ) : (
                                    <Tooltip title="Adresse mail non renseigné">
                                        <span>
                                            <Button
                                                disabled
                                                size="small"
                                                color="secondary"
                                                variant="contained"
                                                endIcon={<MailIcon />}>
                                                Envoyer
                                            </Button>
                                        </span>
                                    </Tooltip>
                                )}
                            </Grid>
                        </Grid>
                    </TableCell>
                </TableRow>
            ))}
        </MuiTable>
    );
};

export default Aot;
